// extracted by css-extract-rspack-plugin
export default {"tableRoot":"table-module__tableRoot__jx8gwvh","tableBodyContainer":"table-module__tableBodyContainer__aLH5pXS","fixedOmnibar":"table-module__fixedOmnibar__ResGJzH"};